.registrations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.registration-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.registration-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.reg-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.reg-header h6 {
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
}

.reg-details {
  margin: 15px 0;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-row .label {
  font-weight: 600;
  color: #666;
  min-width: 100px;
}

.detail-row .value {
  color: #333;
  text-align: right;
  flex: 1;
}

.reg-actions {
  display: flex;
  gap: 8px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 2px solid #f0f0f0;
  flex-wrap: wrap;
}

.reg-actions .btn {
  flex: 1;
  min-width: 70px;
  font-size: 12px;
  padding: 6px 10px;
}

/* Edit Form Styles */
.edit-form {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 6px;
  margin-top: 15px;
}

.edit-form .form-label {
  font-weight: 600;
  color: #333;
  font-size: 13px;
  margin-bottom: 6px;
}

.edit-form .form-control {
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  padding: 8px 12px;
}

.edit-form .form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* QR Code Modal */
.modal {
  display: block;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.ticket-display {
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  margin: 0 -16px;
}

.ticket-number {
  font-family: 'Courier New', monospace;
  letter-spacing: 2px;
  font-weight: bold;
  color: #fff;
  margin: 10px 0;
}

.qr-code-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  display: inline-block;
}

.qr-code-image {
  max-width: 200px;
  height: auto;
}

.ticket-info {
  margin-top: 15px;
  font-size: 14px;
}

.ticket-info p {
  margin: 5px 0;
}

/* Responsive */
@media (max-width: 768px) {
  .registrations-grid {
    grid-template-columns: 1fr;
  }

  .detail-row {
    flex-direction: column;
  }

  .detail-row .label {
    min-width: auto;
    margin-bottom: 4px;
  }

  .detail-row .value {
    text-align: left;
  }

  .reg-actions .btn {
    flex: 0 1 calc(33.333% - 6px);
  }
}
